import React from 'react';

import SVGIcon from '../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../common/edlio-js/models/BackendLocalization';

export default class InputHint extends React.Component {
	constructor(props) {
		super(props);
	}

	add = () => {
		this.refs.addHintLink.classList.toggle('hidden');
		this.refs.hintInput.classList.toggle('hidden');
		this.refs.tools.classList.toggle('hidden');
		this.refs.hintcontainer.classList.toggle('display-input');
	}

	remove = () => {
		this.refs.addHintLink.classList.toggle('hidden');
		this.refs.hintInput.classList.toggle('hidden');
		this.refs.tools.classList.toggle('hidden');
		this.refs.hintInput.value = '';
        this.refs.hintcontainer.classList.toggle('display-input');
	}

	render() {
		const addLinkClasses = ( this.props.hint.length === 0 ) ? 'add' : 'hidden add';
		const inputClasses = ( this.props.hint.length === 0 ) ? 'hidden' : '';
		const toolsClasses = ( this.props.hint.length === 0 ) ? 'hidden tools' : 'tools';
		const hintClasses = (this.props.hint.length === 0) ? 'hint' : 'hint display-input';

		let localization = new Localization(window.edlio.localizations);

		let placeholder,label;

		const type = this.props.type;
		if (type && type === "MULTI_CHOICE_PAY_GROUP") {
			label = localization.localize('Add Description');
			placeholder = localization.localize('Description');
		} else {
			// Default placeholder/labels if not type specified
			label = localization.localize('Add Hint');
			placeholder = localization.localize('Optional hint text');
		}

		// placeholder/label override if specified in props
		if (this.props.label) {
			label = this.props.label;
		}
		if (this.props.placeholder) {
			placeholder = this.props.placeholder;
		}

		return (
			<div className={hintClasses} ref='hintcontainer'>
				<span className='content'>
					{this.props.hint}
				</span>
				<input
					ref='hintInput'
					type='text'
					className={inputClasses}
					defaultValue={this.props.hint}
					placeholder={localization.localize(placeholder)}
				/>
				<aside ref='tools' className={toolsClasses}>
					<a className='remove tool' href='javascript:;' onClick={this.remove}>
						<SVGIcon name='trash-o' />
					</a>
				</aside>
				<a ref='addHintLink' className={addLinkClasses} href='javascript:;' onClick={this.add}>{localization.localize(label)}</a>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/widgets/input-hint.js